export const formatCurrency = (v, currency = "COP") => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(num)
}

export const formatNumber = (v, decimals = 0) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num)
}

export const formatPercent = (v, decimals = 2) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return `${num.toFixed(decimals)}%`
}

export const formatFecha = iso => {
  if (!iso) return "—"
  try {
    return new Date(iso).toLocaleDateString("es-CO", { year: "numeric", month: "short", day: "2-digit" })
  } catch { return iso }
}

export const PALETA = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#ec4899", "#06b6d4", "#84cc16", "#f97316", "#6366f1",
]

export const colorPara = i => PALETA[i % PALETA.length]

export const TIPO_COMPROBANTE = {
  "01": "Factura",
  "02": "Nota débito",
  "03": "Nota crédito",
  "04": "Documento soporte",
  "05": "Doc. equivalente",
  "91": "Nota crédito",
  "92": "Nota débito",
  "95": "Doc. equivalente",
}

// Códigos DIAN de tipo de documento de identificación
export const TIPO_DOCUMENTO_DIAN = [
  { value: "11", label: "Registro civil" },
  { value: "12", label: "Tarjeta de identidad" },
  { value: "13", label: "Cédula de ciudadanía" },
  { value: "21", label: "Tarjeta de extranjería" },
  { value: "22", label: "Cédula de extranjería" },
  { value: "31", label: "NIT" },
  { value: "41", label: "Pasaporte" },
  { value: "42", label: "Documento de identificación extranjero" },
  { value: "43", label: "Sin identificación del exterior" },
  { value: "44", label: "RUT extranjero" },
  { value: "46", label: "Tipo de documento diferente" },
  { value: "47", label: "PEP" },
]

export const tipoDocumentoLabel = code => {
  const t = TIPO_DOCUMENTO_DIAN.find(x => x.value === code)
  return t ? t.label : code || "—"
}

// Etiquetas de impuestos detallados (orden visual en el UI)
export const IMPUESTOS_LABELS = [
  { key: "iva_19", label: "IVA 19%" },
  { key: "iva_16", label: "IVA 16%" },
  { key: "iva_5",  label: "IVA 5%"  },
  { key: "iva_0",  label: "IVA 0%"  },
  { key: "inc_8",  label: "INC 8%"  },
  { key: "inc_16", label: "INC 16%" },
  { key: "inc_4",  label: "INC 4%"  },
  { key: "inc_2",  label: "INC 2%"  },
  { key: "ibua",   label: "IBUA"    },
  { key: "icl",    label: "ICL"     },
  { key: "icui",   label: "ICUI"    },
  { key: "inpp",   label: "INPP"    },
  { key: "otros_impuestos", label: "Otros" },
]

// Calcular fecha_inicio y fecha_fin del mes
export const rangoDelMes = (year, month) => {
  const yyyy = String(year)
  const mm = String(month).padStart(2, "0")
  const ultimo = new Date(year, month, 0).getDate()
  return {
    fecha_inicio: `${yyyy}-${mm}-01`,
    fecha_fin: `${yyyy}-${mm}-${String(ultimo).padStart(2, "0")}`,
  }
}

// Origen del nombre canónico → config visual
export const origenConfig = origen => {
  if (origen === "manual") {
    return { color: "#065f46", bg: "#d1fae5", label: "Manual", icon: "check-decagram", desc: "Nombre validado manualmente" }
  }
  if (origen === "algoritmo") {
    return { color: "#92400e", bg: "#fef3c7", label: "Auto", icon: "robot-outline", desc: "Detectado automáticamente — revisar" }
  }
  return { color: "#475569", bg: "#f1f5f9", label: origen || "—", icon: "help-circle-outline", desc: "" }
}
